import {
  ProductionStatusActiveSet,
  ProductionStatusEnum,
  ProductionStatusFailedSet,
  ProductionStatusFinishedSet,
  ProductionStatusNotStartedSet,
  ProductionStatusTerminalSet,
} from "../../enums";

/**
 * Returns true if production has not been started yet.
 */
export const isProductionStatusNotStarted = (
  status: ProductionStatusEnum | undefined,
): boolean => {
  if (!status) {
    return false;
  }

  return ProductionStatusNotStartedSet.has(status);
};

/**
 * Returns true if production is actively running.
 */
export const isProductionStatusActive = (
  status: ProductionStatusEnum | undefined,
): boolean => {
  if (!status) {
    return false;
  }

  return ProductionStatusActiveSet.has(status);
};

/**
 * Returns true if production has failed or been aborted.
 */
export const isProductionStatusFailed = (
  status: ProductionStatusEnum | undefined,
): boolean => {
  if (!status) {
    return false;
  }

  return ProductionStatusFailedSet.has(status);
};

/**
 * Returns true if production is in a terminal state and will not change anymore.
 */
export const isProductionStatusTerminal = (
  status: ProductionStatusEnum | undefined,
): boolean => {
  if (!status) {
    return false;
  }

  return ProductionStatusTerminalSet.has(status);
};

/**
 * Returns true if production has successfully finished.
 */
export const isProductionStatusFinished = (
  status: ProductionStatusEnum | undefined,
): boolean => {
  if (!status) {
    return false;
  }

  return ProductionStatusFinishedSet.has(status);
};
